var render = function render(){
  var _vm$selectedData, _vm$selectedData2, _vm$selectedData3, _vm$selectedData4, _vm$selectedData4$las, _vm$selectedData5, _vm$selectedData6, _vm$selectedData7, _vm$selectedData8, _vm$selectedData9, _vm$selectedData10, _vm$selectedData11, _vm$selectedData12, _vm$selectedData13, _vm$selectedData14, _vm$selectedData15, _vm$selectedData15$jo, _vm$selectedData16, _vm$selectedData17, _vm$selectedData17$jo, _vm$selectedData18, _vm$selectedData19, _vm$selectedData19$jo, _vm$selectedData19$jo2, _vm$selectedData20, _vm$selectedData20$pm, _vm$selectedData20$pm2, _vm$selectedData21, _vm$selectedData21$jo, _vm$selectedData21$jo2, _vm$selectedData22, _vm$selectedData22$pm, _vm$selectedData22$pm2, _vm$selectedData23, _vm$selectedData23$jo, _vm$selectedData23$jo2, _vm$selectedData24, _vm$selectedData24$pm, _vm$selectedData24$pm2, _vm$selectedData25, _vm$selectedData25$jo, _vm$selectedData26, _vm$selectedData26$pm, _vm$selectedData27, _vm$selectedData28, _vm$selectedData28$jo, _vm$selectedData29, _vm$selectedData29$jo, _vm$selectedData30, _vm$selectedData31, _vm$selectedData32, _vm$selectedData33, _vm$selectedData33$ma, _vm$selectedData34, _vm$selectedData35, _vm$selectedData36, _vm$selectedData36$ma, _vm$selectedData37, _vm$selectedData38, _vm$selectedData38$ma, _vm$selectedData39, _vm$selectedData39$jo, _vm$selectedData40, _vm$selectedData40$pm, _vm$selectedData41, _vm$selectedData41$lo, _vm$selectedData42, _vm$selectedData42$lo;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card p-3"
  }, [!_vm.isApprovalMode ? _c('CustomNav', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.rightTabs
    },
    on: {
      "item-click": function itemClick(tab) {
        return _vm.activeTabRight = tab;
      }
    }
  }) : _vm._e(), _vm.isApprovalMode || _vm.activeTabRight == 1 ? [_c('PmsFleetDetailHeader', {
    attrs: {
      "selectedData": _vm.selectedData
    }
  }), _vm._m(0), _c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [!_vm.hideLastMaintenance ? [_c('tr', [_c('td', {
    staticClass: "text-muted",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(" Last Maintenance Date ")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData = _vm.selectedData) === null || _vm$selectedData === void 0 ? void 0 : _vm$selectedData.last_maintenance_date)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Last Maintenance Hours")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber((_vm$selectedData2 = _vm.selectedData) === null || _vm$selectedData2 === void 0 ? void 0 : _vm$selectedData2.last_maintenance_hours)) + " Hours ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Last Maintenance Cost")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency((_vm$selectedData3 = _vm.selectedData) === null || _vm$selectedData3 === void 0 ? void 0 : _vm$selectedData3.last_maintenance_cost)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Last Maintenance Attachment")]), _c('td', [(_vm$selectedData4 = _vm.selectedData) !== null && _vm$selectedData4 !== void 0 && (_vm$selectedData4$las = _vm$selectedData4.last_maintenance_attachments) !== null && _vm$selectedData4$las !== void 0 && _vm$selectedData4$las.length ? _vm._l((_vm$selectedData5 = _vm.selectedData) === null || _vm$selectedData5 === void 0 ? void 0 : _vm$selectedData5.last_maintenance_attachments, function (file, idx) {
    return _c('b-badge', {
      key: "last-att-".concat(idx),
      staticClass: "mr-2 cursor-pointer",
      attrs: {
        "variant": "warning",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.onPreview(file === null || file === void 0 ? void 0 : file.fileurl);
        }
      }
    }, [_vm._v(" " + _vm._s(file.filename) + " "), _c('i', {
      staticClass: "fa fa-download ml-2",
      staticStyle: {
        "font-size": "12px"
      }
    })]);
  }) : [_vm._v("-")]], 2)]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Last Maintenance Notes")]), _c('td', {
    staticClass: "font-semibold text-black",
    domProps: {
      "innerHTML": _vm._s(((_vm$selectedData6 = _vm.selectedData) === null || _vm$selectedData6 === void 0 ? void 0 : _vm$selectedData6.last_maintenance_notes) || '-')
    }
  })])] : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-muted",
    style: _vm.hideLastMaintenance ? 'width: 40%' : undefined
  }, [_vm._v(" Due Maintenance ")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [((_vm$selectedData7 = _vm.selectedData) === null || _vm$selectedData7 === void 0 ? void 0 : _vm$selectedData7.triggers) == 'CALENDAR' ? [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData8 = _vm.selectedData) === null || _vm$selectedData8 === void 0 ? void 0 : _vm$selectedData8.possible_maintenance_date)) + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber((_vm$selectedData9 = _vm.selectedData) === null || _vm$selectedData9 === void 0 ? void 0 : _vm$selectedData9.possible_maintenance_hours) || '0') + " Hours ")]], 2)]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.hideLastMaintenance ? 'Maintenance Date' : 'Current Maintenance Date') + " ")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData10 = _vm.selectedData) === null || _vm$selectedData10 === void 0 ? void 0 : _vm$selectedData10.maintenance_date)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.hideLastMaintenance ? 'Maintenance Hours' : 'Current Maintenance Hours') + " ")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData11 = _vm.selectedData) !== null && _vm$selectedData11 !== void 0 && _vm$selectedData11.maintenance_running_hours ? _vm.formatNumber((_vm$selectedData12 = _vm.selectedData) === null || _vm$selectedData12 === void 0 ? void 0 : _vm$selectedData12.maintenance_running_hours) + ' Hours' : '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.hideLastMaintenance ? 'Maintenance Cost' : 'Current Maintenance Cost') + " ")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency((_vm$selectedData13 = _vm.selectedData) === null || _vm$selectedData13 === void 0 ? void 0 : _vm$selectedData13.cost)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.hideLastMaintenance ? 'Maintenance Attachment' : 'Current Maintenance Attachment') + " ")]), _c('td', [_vm.currentAttachments.length ? _vm._l(_vm.currentAttachments, function (file, idx) {
    return _c('b-badge', {
      key: "current-att-".concat(idx),
      staticClass: "mr-2 cursor-pointer",
      attrs: {
        "variant": "warning",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.onPreview(file === null || file === void 0 ? void 0 : file.fileurl);
        }
      }
    }, [_vm._v(" " + _vm._s(file.filename) + " "), _c('i', {
      staticClass: "fa fa-download ml-2",
      staticStyle: {
        "font-size": "12px"
      }
    })]);
  }) : [_vm._v("-")]], 2)]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.hideLastMaintenance ? 'Maintenance Notes' : 'Current Maintenance Notes') + " ")]), _c('td', {
    staticClass: "font-semibold text-black",
    domProps: {
      "innerHTML": _vm._s(((_vm$selectedData14 = _vm.selectedData) === null || _vm$selectedData14 === void 0 ? void 0 : _vm$selectedData14.notes) || '-')
    }
  })])], 2)]), _vm._m(1), _c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-muted",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Job Code")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData15 = _vm.selectedData) === null || _vm$selectedData15 === void 0 ? void 0 : (_vm$selectedData15$jo = _vm$selectedData15.job_library) === null || _vm$selectedData15$jo === void 0 ? void 0 : _vm$selectedData15$jo.code) || ((_vm$selectedData16 = _vm.selectedData) === null || _vm$selectedData16 === void 0 ? void 0 : _vm$selectedData16.job_code) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Name")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData17 = _vm.selectedData) === null || _vm$selectedData17 === void 0 ? void 0 : (_vm$selectedData17$jo = _vm$selectedData17.job_library) === null || _vm$selectedData17$jo === void 0 ? void 0 : _vm$selectedData17$jo.name) || ((_vm$selectedData18 = _vm.selectedData) === null || _vm$selectedData18 === void 0 ? void 0 : _vm$selectedData18.job_name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Equipment Category")]), _c('td', {
    staticClass: "font-semibold text-black text-uppercase"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData19 = _vm.selectedData) === null || _vm$selectedData19 === void 0 ? void 0 : (_vm$selectedData19$jo = _vm$selectedData19.job_library) === null || _vm$selectedData19$jo === void 0 ? void 0 : (_vm$selectedData19$jo2 = _vm$selectedData19$jo.maintenance_component) === null || _vm$selectedData19$jo2 === void 0 ? void 0 : _vm$selectedData19$jo2.component_name) || ((_vm$selectedData20 = _vm.selectedData) === null || _vm$selectedData20 === void 0 ? void 0 : (_vm$selectedData20$pm = _vm$selectedData20.pms_vehicle) === null || _vm$selectedData20$pm === void 0 ? void 0 : (_vm$selectedData20$pm2 = _vm$selectedData20$pm.maintenance_component) === null || _vm$selectedData20$pm2 === void 0 ? void 0 : _vm$selectedData20$pm2.component_name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Equipment")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData21 = _vm.selectedData) === null || _vm$selectedData21 === void 0 ? void 0 : (_vm$selectedData21$jo = _vm$selectedData21.job_library) === null || _vm$selectedData21$jo === void 0 ? void 0 : (_vm$selectedData21$jo2 = _vm$selectedData21$jo.maintenance_master) === null || _vm$selectedData21$jo2 === void 0 ? void 0 : _vm$selectedData21$jo2.equipment_name) || ((_vm$selectedData22 = _vm.selectedData) === null || _vm$selectedData22 === void 0 ? void 0 : (_vm$selectedData22$pm = _vm$selectedData22.pms_vehicle) === null || _vm$selectedData22$pm === void 0 ? void 0 : (_vm$selectedData22$pm2 = _vm$selectedData22$pm.maintenance_master) === null || _vm$selectedData22$pm2 === void 0 ? void 0 : _vm$selectedData22$pm2.equipment_name) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Type")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData23 = _vm.selectedData) === null || _vm$selectedData23 === void 0 ? void 0 : (_vm$selectedData23$jo = _vm$selectedData23.job_library) === null || _vm$selectedData23$jo === void 0 ? void 0 : (_vm$selectedData23$jo2 = _vm$selectedData23$jo.maintenance_job_type) === null || _vm$selectedData23$jo2 === void 0 ? void 0 : _vm$selectedData23$jo2.job_type_index) || ((_vm$selectedData24 = _vm.selectedData) === null || _vm$selectedData24 === void 0 ? void 0 : (_vm$selectedData24$pm = _vm$selectedData24.pms_vehicle) === null || _vm$selectedData24$pm === void 0 ? void 0 : (_vm$selectedData24$pm2 = _vm$selectedData24$pm.maintenance_job_type) === null || _vm$selectedData24$pm2 === void 0 ? void 0 : _vm$selectedData24$pm2.job_type_index) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Method")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData25 = _vm.selectedData) === null || _vm$selectedData25 === void 0 ? void 0 : (_vm$selectedData25$jo = _vm$selectedData25.job_library) === null || _vm$selectedData25$jo === void 0 ? void 0 : _vm$selectedData25$jo.method) || ((_vm$selectedData26 = _vm.selectedData) === null || _vm$selectedData26 === void 0 ? void 0 : (_vm$selectedData26$pm = _vm$selectedData26.pms_vehicle) === null || _vm$selectedData26$pm === void 0 ? void 0 : _vm$selectedData26$pm.method) || '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Interval")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [((_vm$selectedData27 = _vm.selectedData) === null || _vm$selectedData27 === void 0 ? void 0 : _vm$selectedData27.triggers) == 'CALENDAR' ? [_vm._v(" " + _vm._s((_vm$selectedData28 = _vm.selectedData) === null || _vm$selectedData28 === void 0 ? void 0 : (_vm$selectedData28$jo = _vm$selectedData28.job_library) === null || _vm$selectedData28$jo === void 0 ? void 0 : _vm$selectedData28$jo.calendar_interval) + " " + _vm._s((_vm$selectedData29 = _vm.selectedData) === null || _vm$selectedData29 === void 0 ? void 0 : (_vm$selectedData29$jo = _vm$selectedData29.job_library) === null || _vm$selectedData29$jo === void 0 ? void 0 : _vm$selectedData29$jo.calendar_type) + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber((_vm$selectedData30 = _vm.selectedData) === null || _vm$selectedData30 === void 0 ? void 0 : _vm$selectedData30.trigger_interval)) + " Hours ")]], 2)]), ((_vm$selectedData31 = _vm.selectedData) === null || _vm$selectedData31 === void 0 ? void 0 : _vm$selectedData31.triggers) == 'COUNTER' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Engine Position")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [[_vm._v(" " + _vm._s(((_vm$selectedData32 = _vm.selectedData) === null || _vm$selectedData32 === void 0 ? void 0 : _vm$selectedData32.power_type_name) || ((_vm$selectedData33 = _vm.selectedData) === null || _vm$selectedData33 === void 0 ? void 0 : (_vm$selectedData33$ma = _vm$selectedData33.maintenance_power_type) === null || _vm$selectedData33$ma === void 0 ? void 0 : _vm$selectedData33$ma.name) || '-') + " ")]], 2)]) : _vm._e(), ((_vm$selectedData34 = _vm.selectedData) === null || _vm$selectedData34 === void 0 ? void 0 : _vm$selectedData34.triggers) == 'COUNTER' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Engine Brand")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(((_vm$selectedData35 = _vm.selectedData) === null || _vm$selectedData35 === void 0 ? void 0 : _vm$selectedData35.power_series_name) || ((_vm$selectedData36 = _vm.selectedData) === null || _vm$selectedData36 === void 0 ? void 0 : (_vm$selectedData36$ma = _vm$selectedData36.maintenance_power_series) === null || _vm$selectedData36$ma === void 0 ? void 0 : _vm$selectedData36$ma.name) || '-') + " - " + _vm._s(((_vm$selectedData37 = _vm.selectedData) === null || _vm$selectedData37 === void 0 ? void 0 : _vm$selectedData37.power_series_model) || ((_vm$selectedData38 = _vm.selectedData) === null || _vm$selectedData38 === void 0 ? void 0 : (_vm$selectedData38$ma = _vm$selectedData38.maintenance_power_series) === null || _vm$selectedData38$ma === void 0 ? void 0 : _vm$selectedData38$ma.model) || '-') + " ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-muted align-top"
  }, [_vm._v("Job Description")]), _c('td', {
    staticClass: "font-semibold text-black job-description",
    domProps: {
      "innerHTML": _vm._s(((_vm$selectedData39 = _vm.selectedData) === null || _vm$selectedData39 === void 0 ? void 0 : (_vm$selectedData39$jo = _vm$selectedData39.job_library) === null || _vm$selectedData39$jo === void 0 ? void 0 : _vm$selectedData39$jo.job_description) || ((_vm$selectedData40 = _vm.selectedData) === null || _vm$selectedData40 === void 0 ? void 0 : (_vm$selectedData40$pm = _vm$selectedData40.pms_vehicle) === null || _vm$selectedData40$pm === void 0 ? void 0 : _vm$selectedData40$pm.job_description) || '-')
    }
  })])])]), _c('TablePostponed', {
    attrs: {
      "selectedData": _vm.selectedData
    }
  }), _vm.isApprovalMode ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-4 pt-3 border-top"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('reject');
      }
    }
  }, [_vm._v(" Reject ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('approve');
      }
    }
  }, [_vm._v("Approve")])], 1) : _vm._e()] : _vm.activeTabRight == 2 ? [_c('MaintenanceCommentFormNew', {
    attrs: {
      "isPreview": "",
      "selectedData": _vm.selectedData
    }
  })] : [(_vm$selectedData41 = _vm.selectedData) !== null && _vm$selectedData41 !== void 0 && (_vm$selectedData41$lo = _vm$selectedData41.logs) !== null && _vm$selectedData41$lo !== void 0 && _vm$selectedData41$lo.length ? [_c('MaintenanceLogs', {
    attrs: {
      "logs": (_vm$selectedData42 = _vm.selectedData) === null || _vm$selectedData42 === void 0 ? void 0 : (_vm$selectedData42$lo = _vm$selectedData42.logs) === null || _vm$selectedData42$lo === void 0 ? void 0 : _vm$selectedData42$lo.map(function (log) {
        var _log$user, _log$user$detail;
        return {
          name: (log === null || log === void 0 ? void 0 : (_log$user = log.user) === null || _log$user === void 0 ? void 0 : (_log$user$detail = _log$user.detail) === null || _log$user$detail === void 0 ? void 0 : _log$user$detail.name) || log.created_by,
          date: log.created_date,
          description: "Changed Status to ".concat(log.status)
        };
      })
    }
  })] : _vm._e()]], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "text-primary my-3"
  }, [_c('strong', [_vm._v("Maintenance Info")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "text-primary my-3"
  }, [_c('strong', [_vm._v("Job Library Info")])]);

}]

export { render, staticRenderFns }